<template>
  <div class="row">
    <!--  HEADER  -->
    <div class="sweet-modal-magic-text-header col-12">
      <img src="static/images/builderall-logo.svg"/>
      <div>
        <!-- <div class="sweet-modal-magic-text-title">{{ $t('ct-edit-text-smart') }} <sup class="ba-badge-beta">Beta</sup>
        </div> -->
        <div class="sweet-modal-magic-text-subtitle">{{ $t('ct-edit-text-smart-obs') }}</div>
      </div>
    </div>

    <!--   CONTENT   -->
    <div class="content-form-steps">
      <form id="form-magic-text" @submit.prevent="getData()">
        <div class="form-group-steps">
          <div class="form-group-steps-number-label">
            <div class="form-group-steps-number">1</div>
            <div class="form-group-steps-label">
              <label for="text-edit-smart-type">{{ $t('ct-text-smart-type') }} </label>
            </div>
          </div>
          <div class="form-group-steps-input">
            <!-- DROPDOWN -->
            <div class="btn-group btn-group-magic-text-input">
              <button :class="{
                'is-invalid': errors.has('selected.type'),
                'has-selected-type': !!selected.type
              }"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="btn btn-magic-text-input dropdown-toggle"
                      data-toggle="dropdown" type="button">
                <template v-if="selected.type">{{ textSelected }}</template>
                <template v-else>{{ $t('ct-choose-text-smart') }}</template>

                <font-awesome-icon class="dropdown-magic-arrow-up" icon="caret-up"/>
                <font-awesome-icon class="dropdown-magic-arrow-down" icon="caret-down"/>
              </button>
              <div class="dropdown-menu">
                <div
                    v-for="(option, idx) in types"
                    :key="idx"
                    class="dropdown-item"
                    @click="selectedType(option.value)"
                >
                  <p :class="{'checked': selected.type === option.value}"
                     class="magic-text-text"
                  >{{ option.text }}</p>
                </div>
              </div>
            </div>
            <span
                v-if="errors.has('selected.type')"
                class="invalid-feedback d-flex"
                v-text="errors.get('selected.type')"
            ></span>
          </div>
        </div>

        <!-- CUSTOM CONTENT -->
        <template v-if="typeIsCustomContent">
          <div class="form-group-steps">
            <div class="form-group-steps-number-label">
              <div class="form-group-steps-number">2</div>
              <div class="form-group-steps-label">
                <label for="text-edit-smart-type">{{ $t('ct-text-smart-description') }}</label>
              </div>
            </div>
            <div class="form-group-steps-input">
             <textarea
                 id="text-edit-smart-description"
                 v-model="selected.message"
                 :class="{
                 'is-invalid': errors.has('selected.message'),
                 'has-selected-type': !!selected.message
               }"
                 class="form-control"
                 cols="30"
                 rows="10"
                 @keyup="errors.clear('selected.message')"
             ></textarea>
              <span
                  v-if="errors.has('selected.message')"
                  class="invalid-feedback"
                  v-text="errors.get('selected.message')"
              ></span>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- STEP 2 -->
          <div class="form-group-steps">
            <div class="form-group-steps-number-label">
              <div class="form-group-steps-number">2</div>
              <div class="form-group-steps-label">
                <label for="text-smart-about">{{ $t('ct-text-smart-about') }}</label>
              </div>
            </div>
            <div class="form-group-steps-input">
              <input
                  id="text-smart-about"
                  v-model="selected.business"
                  :class="{
                  'is-invalid': errors.has('selected.business'),
                  'has-selected-type': !!selected.business
                }"
                  :placeholder="$t('ct-text-smart-about-plch')"
                  class="form-control"
                  type="text"
                  @keyup="errors.clear('selected.business')"
              >
              <span
                  v-if="errors.has('selected.business')"
                  class="invalid-feedback"
                  v-text="errors.get('selected.business')"
              ></span>
            </div>
          </div>

          <!-- STEP 3 -->
          <div class="form-group-steps">
            <div class="form-group-steps-number-label">
              <div class="form-group-steps-number">3</div>
              <div class="form-group-steps-label">
                <label for="text-smart-product">{{ $t('ct-text-smart-product') }} </label>
              </div>
            </div>
            <div class="form-group-steps-input">
              <input id="text-smart-product" v-model="selected.product"
                     :class="{
                      'is-invalid': errors.has('selected.product'),
                      'has-selected-type': !!selected.product
                      }"
                     :placeholder="$t('ct-text-smart-product-plch')"
                     class="form-control"
                     type="text"
                     @keyup="errors.clear('selected.product')">
              <span
                  v-if="errors.has('selected.product')"
                  class="invalid-feedback"
                  v-text="errors.get('selected.product')"
              ></span>
            </div>
          </div>
        </template>

        <div class="text-center">
          <button v-if="loading" class="btn btn-primary btn-action-magic-text" disabled type="button">
            {{ $t('ct-generating') }}...
            <span aria-hidden="true" class="spinner-border spinner-border-sm mx-2" role="status"></span>
          </button>
          <button v-else class="btn btn-primary btn-action-magic-text text-uppercase" form="form-magic-text"
                  type="submit"> {{
              $t('ct-text-generate')
            }}
          </button>
        </div>
      </form>

      <div v-if="loading" class="magic-text-sample-box-content">
        <div v-for="index in loadingCount" :key="index" class="magic-text-sample-box with-loading">
          <div>
            ...
          </div>
          <button class="btn btn-secondary" disabled> {{ $t('ct-text-choose') }}</button>
        </div>
      </div>

      <div v-else-if="response.length > 0" class="magic-text-sample-box-content">
        <template v-if="typeIsCustomContent">
          <div class="magic-text-sample-box">
            <div class="card-text">
              <p
                  v-for="(resp, index) in customContent"
                  :key="index"
              >{{ resp }}</p>
            </div>
            <button
                class="btn btn-primary"
                @click="chooseText(responseCustomContent)"> {{ $t('ct-text-choose') }}
            </button>
          </div>
        </template>

        <template v-else>
          <template v-for="(resp, index) in response">
            <div v-if="resp !== '' && !/^Sure! Here/i.test(resp)" :key="index" class="magic-text-sample-box">
              <div class="card-text">
                <p>{{ resp.replace("\\", "") }}</p>
              </div>
              <button
                  class="btn btn-primary"
                  @click="chooseText(resp)"> {{ $t('ct-text-choose') }}
              </button>
            </div>
          </template>
        </template>
      </div>

    </div>
  </div>
</template>
<script>

import Errors from "../../../js/base/Errors";
import { generateTexts } from "../../../js/services/editor/website";

export default {
  data() {
    return {
      message: '',
      selected: {
        type: '',
        message: '',
        business: '',
        product: ''
      },
      types: [
        {
          value: 'create-3-sample-headlines',
          text: this.$t('ct-text-smart-type-1')
        },
        {
          value: 'create-3-sample-subheadlines',
          text: this.$t('ct-text-smart-type-2')
        },
        {
          value: 'create-3-sample-paragraphs',
          text: this.$t('ct-text-smart-type-3')
        },
        {
          value: 'create-one-paragraph',
          text: this.$t('ct-text-smart-type-4')
        },
        {
          value: 'create-custom-content',
          text: this.$t('ct-text-smart-type-5')
        },
      ],
      response: [],
      loadingCount: 3,
      originalContent: '',
      idEditor: 0,
      text: '',
      editing: false,
      blur: true,
      editor: null,
      open: false,
      element: null,
      loading: false,
      errors: new Errors(),
    };
  },
  watch: {
    'selected.type': function () {
      this.response = [];

      if (this.isCreateThreeSample) {
        this.loadingCount = 3
        this.errors.clear();
      } else {

        this.loadingCount = 1
      }
    }
  },
  computed: {
    isCreateThreeSample() {
      return this.selected.type.indexOf('create-3-sample') > -1
    },
    typeIsCustomContent() {
      return this.selected.type === 'create-custom-content'
    },
    customContent() {
      return this.response.filter((resp) => resp !== '')
    },
    responseCustomContent() {
      return this.customContent.join('<br>')
    },

    textSelected() {
      const optionSelected = this.optionSelected()
      return optionSelected ? optionSelected.text : ''
    },

    apiUrl() {
       return typeof process.env.API_URL !== 'undefined' ? process.env.API_URL : 'https://cheetah-api.builderall.com';
    },
  },
  methods: {
    optionSelected() {
      return this.types.find(type => type.value === this.selected.type)
    },
    selectedType(type) {
      this.selected.type = type
      this.errors.clear('selected.type')
    },
    validate() {
      if (!this.selected.type && !(this.selected.type > 0)) {
        this.errors.add('type', 'validation-required', 'selected');
      }

      if (this.typeIsCustomContent) {
        if (!this.selected.message && !(this.selected.message > 0)) {
          this.errors.add('message', 'validation-required', 'selected');
        }
      } else {

        if (!this.selected.business && !(this.selected.business > 0)) {
          this.errors.add('business', 'validation-required', 'selected');
        }

        if (!this.selected.product && !(this.selected.product > 0)) {
          this.errors.add('product', 'validation-required', 'selected');
        }
      }

      return this.errors.any();
    },
    resetSearch() {
      this.message = '';
      this.response = [];
      this.selected = {
        type: '',
        message: '',
        business: '',
        product: ''
      }
      this.errors.clear();
    },
    makeMessage() {
      if (this.typeIsCustomContent) {
        return `${this.$t('ct-magic-text-prompt-custom')}: ${this.selected.message}`;
      } else {
        const startPrompt = `${this.textSelected} ${this.$t('ct-magic-text-for-business')} ${this.selected.business}`
        const endPrompt = `${this.$t('ct-magic-text-about')} ${this.selected.product} ${this.$t('ct-magic-text-for-one-website')}`
        const breadkLine = this.isCreateThreeSample ? this.$t('ct-magic-text-three-breack-line') : this.$t('ct-magic-text-one-breack-line')

        return `${startPrompt} ${endPrompt}, ${this.$t('ct-magic-text-prompt-end')}, ${breadkLine}.`
      }
    },
    getData() {
      if (this.validate()) return;

      this.message = this.makeMessage();
      this.loading = true;
      this.response = [];

      generateTexts(this.message)
        .then(response => {
          if(response.data.success) this.response = response.data.items;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => this.loading = false);
    },
    chooseText(text) {
      let vm = this;

      vm.element.updateContent(text, true);

      this.$snotify.success(
        this.$t('ct-saved-successfully')
      );

      this.$emit('closePopup');

      setTimeout(() => {
        for (let instance in CKEDITOR.instances) {
          CKEDITOR.instances[instance].destroy();
        }
      }, 0)
      vm.editing = false;
      vm.open = false;
      this.resetSearch()
    },
    showEditor(elem) {

      if (!this.open) {
        this.resetSearch()
        this.open = true;
        this.$nextTick(() => {
          this.element = elem;
        })
      }
    }

  },
}
</script>

<style lang="scss">
.sweet-modal-magic-text .sweet-modal {
  background-color: #FFF !important;
  font-family: Montserrat;
  padding-top: 0 !important;
  max-width: 877px;
}

.sweet-modal-magic-text {
  .invalid-feedback {
    font-family: Montserrat;
  }

  .form-magic-text {
    padding: 10px 20px !important;
  }

  .sweet-action-close {
    margin-top: 15px;
    color: #FF3636 !important;
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60px;
    border-bottom: 1px solid #c9c9c9;
    margin-bottom: 1rem;
    padding: 1rem 0;

    img {
      width: 50px;
      margin-right: 8px;
    }
  }

  &-title {
    color: #4D5D71;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1.32px;
    position: relative;
    display: inline-flex;

    .ba-badge-beta {
      right: -40px !important;
      font-size: 9px !important;
    }
  }

  &-subtitle {
    color: #8D9EB5;
    leading-trim: both;
    text-edge: cap;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.6px;
  }
}

.content-form-steps {
  display: flex;
  flex-direction: column;
  width: 639px;
  margin: 0 auto;

  .form-group-steps {
    margin-bottom: 2rem;

    .form-group-steps-number-label {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      label {
        color: #4D5D71;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.66px;
        margin: 0;
        padding: 0;
        text-align: left;
      }
    }

    .dropdown-toggle {

      &::after {
        display: none;
      }

      .dropdown-magic-arrow-up,
      .dropdown-magic-arrow-down {
        color: #7191b4 !important;
        font-size: 20px !important;
      }

      &[aria-expanded="true"] {
        .dropdown-magic-arrow-up {
          display: inline-block;
        }

        .dropdown-magic-arrow-down {
          display: none;
        }
      }

      &[aria-expanded="false"] {
        .dropdown-magic-arrow-up {
          display: none;
        }

        .dropdown-magic-arrow-down {
          display: inline-block;
        }
      }
    }

    .dropdown-menu {
      width: 100% !important;

      .dropdown-magic-arrow-up {

      }

      .dropdown-item {
        cursor: pointer;

        &:hover .magic-text-text {
          color: #0072E1 !important;
        }
      }
    }

    .dropdown-menu .dropdown-item:active {
      background-color: #f8f9fa !important;
    }

    .btn-magic-text-input {
      color: rgba(77, 93, 113, 0.94) !important;
      font-family: Montserrat !important;
      font-style: normal;
      font-weight: 500 !important;
      line-height: normal;
      letter-spacing: 0.66px;
      border-radius: 8px !important;
      margin: 0 !important;
      width: 100%;
      justify-content: space-between !important;
      outline: none;
      box-shadow: none !important;

      &.is-invalid {
        border-color: #FA4B57;
      }
    }

    .btn-group-magic-text-input {
      width: 100%;
      font-family: Montserrat;
      font-size: 12px;

      .magic-text-text {
        color: #7191B4;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.66px;
        margin: 0;
        cursor: pointer;
        font-family: Montserrat !important;
        min-height: 34px;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &.checked {
          color: #0072E1;
        }

        &:hover {
          opacity: 0.8;
          color: #0072E1;
        }
      }

      input:checked + label {
        color: #0072E1;
      }

      .form-check label {
        color: #7191B4;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.66px;
      }
    }

    textarea.form-control {
      padding-top: 0.5rem !important;
    }

    .form-control, .btn-magic-text-input {
      min-height: 60px !important;
      border-radius: 8px;
      border: 1px solid rgba(217, 217, 217, 0.50);
      border-color: rgba(217, 217, 217, 0.50);
      background: #F5F7FE;
      padding: 0.375rem 1.25rem;
      font-family: Montserrat;
      font-size: 12px;

      color: #0072E1;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.66px;



      &.has-selected-type {
        color: #0072E1 !important;
        font-weight: 700 !important;
        border: 1px solid #0072E1;
      }

      &::placeholder {
        color: rgba(77, 93, 113, 0.94);
        font-style: normal;
        font-weight: 300;
        line-height: normal;
        letter-spacing: 0.66px;
      }

      &.is-invalid {
        border-color: #FA4B57;
      }
    }
  }
}


.form-group-steps-number {
  width: 36px;
  min-width: 36px;
  height: 36px;
  font-size: 18px;
  color: #FFF;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.99px;
  font-family: Montserrat;
  background-color: #0072E1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 9px;
}

.form-group-steps-label {
  color: #4D5D71;
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.ba-badge-beta {
  position: absolute;
  right: -15px !important;
  top: -10px !important;
  background-color: #fff !important;
  color: #0080fc !important;
  border: 1px solid #0080fc !important;
  font-size: 8px !important;
  border-radius: 5px !important;
  text-transform: capitalize;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.btn-action-magic-text {
  border-radius: 8px !important;
  padding: 10px 10px !important;
  margin: 0 !important;
}

.btn-magic-text {
  border-radius: 8px !important;
  background: #F1F2F8;
  padding: 0px 10px !important;
  color: #0072E1;
  font-size: 12px !important;
  height: 30px !important;
  min-height: 30px !important;
  font-weight: 700 !important;
  margin: 0 15px;
  position: relative;
  text-transform: uppercase !important;
  min-width: 100px;
  position: relative;

  &:hover {
    color: #FFFFFF;
    background-color: #0072E1 !important;

    &::before {
      width: calc(100% + 20px);
      min-width: 115px;
      content: " ";
      background-image: url('../../../../static/images/bg-magic-text.svg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: -10px;
      top: -15px;
      height: 60px;

      transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }
  }
}
</style>
<style lang="scss" scoped>


.form-group {
  margin-bottom: 20px;
}

.magic-text-sample-box-content {
  margin-top: 40px;
}

.magic-text-sample-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  min-height: 80px;
  border-radius: 8px;
  border: 1px solid rgba(217, 217, 217, 0.50);
  color: #4D5D71;
  background: #F5F7FE;
  margin-bottom: 1.5rem;

  .btn-primary {
    background-color: #8E9EB5;
    border-radius: 8px !important;
  }

  &.with-loading {
    opacity: 0.5;
  }

  div {
    height: 100%;
  }

  &:not(.with-loading):hover {
    border: 1px solid #0072E1;

    .btn-primary {
      color: #FFF;
      background-color: #0072E1;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/editor/base/MagicTextOpen.vue